/* DEPRECATED — Promise-only API; results are not stored in Redux. */
import Context from 'managers/Context';
import { BILLBOARD } from 'constants/Entities';

export function getFuzzySearch({
    entity,
    field,
    search,
    entityDependence,
    entityDependenceId,
    usersFromService = '',
}) {
    const encodedText = encodeURIComponent(search);

    return (dispatch) =>
        new Promise((resolve, reject) => {
            if (entity === 'billboard') {
                Context.entityManager.getEntitiesManager(BILLBOARD).getBillboardList(
                    0,
                    30,
                    (result) => resolve(result),
                    (error) => reject(error),
                );
                return;
            }

            Context.domainManager.getFuzzySearch(
                entity,
                field,
                encodedText,
                entityDependence,
                entityDependenceId,
                usersFromService,
                (result) => resolve(result),
                (error) => reject(error),
            );
        });
}

export function clearFuzzySearch() {
    return () => {};
}

export function autoCompleteSearch({
    entity,
    field,
    search,
    feature,
    entityFilter,
    skipPermissions,
    parentField,
    parentValue,
    idParent,
}) {
    const encodedSearch = encodeURIComponent(search);

    return (dispatch) =>
        new Promise((resolve, reject) => {
            Context.domainManager.autoCompleteSearch({
                entity,
                field,
                search: encodedSearch,
                feature,
                parentField,
                parentValue,
                idParent,
                entityFilter,
                skipPermissions,
                success: (result) => resolve(result),
                error: () => reject(),
            });
        });
}
